'use client';
import React, { useEffect, useState } from 'react';
import { Subject } from '@bufdir/statistics-pages-components';
import { toSubjectProps } from '../utils';

type Props = {
  data: any;
};

const PageSubject: React.FC<Props> = ({ data }) => {
  const [hash, setHash] = useState('');

  useEffect(() => {
    setHash(window.location.hash);
  }, []);

  const subjectProps = toSubjectProps(data.data[0]);

  return <Subject {...subjectProps} hash={hash} />;
};

export default PageSubject;
